export default function /* @ngInject */ run(userPermissions, $rootScope) {
    let permissionRegistry = ['view_profile', 'view_plan', 'view_team'];
    $rootScope.ready = false;
    userPermissions.get(permissionRegistry)
        .then(()=> { $rootScope.ready = true; })
        .catch(() => { /* todo: handle app error */ });
}



// WEBPACK FOOTER //
// ./user/user-run.js